import React from 'react';
import ReactMarkdown from 'react-markdown';
import SectionHeader from './SectionHeader';

// Long-form editorial body for CMS landing pages. `description` is markdown; a leading H1
// is dropped because the page already renders its own H1 in the hero.
const MD = {
  h1: () => null,
  h2: ({ children }) => <h2 className="font-serif text-h2 text-warm-black font-medium mt-12 mb-4">{children}</h2>,
  h3: ({ children }) => <h3 className="font-serif text-h3 text-warm-black font-medium mt-8 mb-3">{children}</h3>,
  p: ({ children }) => <p className="text-body-l text-muted leading-[1.75]">{children}</p>,
  strong: ({ children }) => <strong className="font-semibold text-warm-black">{children}</strong>,
  ul: ({ children }) => <ul className="list-disc pl-6 space-y-2 text-body-l text-muted">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-6 space-y-2 text-body-l text-muted">{children}</ol>,
  a: ({ href, children }) => <a href={href} className="text-gold underline underline-offset-4">{children}</a>,
};

export default function LandingLongFormSection({ text, eyebrow = 'Σε βάθος', title = 'Αναλυτικά', titleEm = 'για την υπηρεσία.' }) {
  const body = (text || '').trim();
  if (!body) return null;

  return (
    <section className="px-[6vw] py-[100px] bg-ivory">
      <div className="max-w-reading mx-auto">
        <SectionHeader eyebrow={eyebrow} title={title} titleEm={titleEm} />
        <div className="space-y-5">
          <ReactMarkdown components={MD}>{body}</ReactMarkdown>
        </div>
      </div>
    </section>
  );
}